<section class="contact-top">
  
            <div class="inner_sec">
                <div class="container">
                <h2>Coatings Solution.</h2>
               </div>


            <div class="product_list coating"> 

               <div class="container">     
                <div class="row">    
                 <div class="col-sm-7 border">  
                    <h3>Coatings</h3>
                     <ul class="top_list">
                         <li *ngFor="let data of coatinglist"> 
                                <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon> {{data.item}}
                         </li>
                     </ul>
                  </div>  

                  <div class="col-sm-4 list">  
                    <h3>Coating Chamber Size</h3>
                     <ul class="top_list">
                         <li> 
                            <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon>
                            Ø720mm X H 930mm
                         </li>
                     </ul>

                     <h3>Coating System</h3>
                     <ul class="top_list">
                         <li> 
                            <lucide-icon name="ArrowRight" class="icon" [size]="18"></lucide-icon>
                            ARC-PVD System
                         </li>
                     </ul>
                  </div>
                </div>  

                </div>

            </div>


            <div class="advapp_sec">
                 
                    <div class="container"> 
                    <h2>Advantage and Applications of Coating</h2>
                    
                    <ul class="top_list">
                        <li *ngFor="let data of advapp"> 
                            <div [innerHTML]="data.item"></div>
                        </li>
                    </ul>
                    </div>
                    
            </div>


            <div class="adv_sec">
              <div class="container">
                <div class="product_list">
                    <h3>Advanced Coatings</h3>
                </div>

                <table [cellPadding]="0" [cellSpacing]="0">
                    <thead>
                      <tr>
                        <th *ngFor="let header of tableData.thead.tr">{{ header.th }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of tableData.tbody.tr">
                        <td *ngFor="let cell of row">{{ cell.td }}</td>
                      </tr>
                    </tbody>
                  </table>
                
              </div>

            </div>     
                
            </div>

    
</section>
